(function(){
  'use strict';
  var isDesignMode = false;
  try {
    isDesignMode = !!(window.Shopify && window.Shopify.designMode);
  } catch (e) {}

  function safeRedirect(url, replace) {
    if (!url || isDesignMode) return;
    if (replace) window.location.replace(url);
    else window.location.href = url;
  }

  /* ── Mobile viewport height fix (100vh bug on iOS/Android) ── */
  function setVH() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
  }
  setVH();
  window.addEventListener('resize', setVH, { passive: true });

  /* ── Duplicate marquee tracks for seamless infinite scroll ── */
  function dupeTrack(sel) {
    var t = document.querySelector(sel);
    if (!t) return;
    var children = Array.prototype.slice.call(t.children);
    children.forEach(function(child) {
      var clone = child.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      t.appendChild(clone);
    });
  }
  dupeTrack('.v-announce-track');
  dupeTrack('.v-trust-track');

  /* ── Brand marquee (JS-driven, pixel-perfect loop) ── */
  (function() {
    var track = document.querySelector('.v-brands-track');
    if (!track) return;
    var sets = track.querySelectorAll('.v-brands-set');
    if (sets.length < 2) return;
    var setWidth = sets[0].offsetWidth;
    if (!setWidth) return;
    var offset = 0;
    var speed = 0.5;
    var last = performance.now();
    function tick(now) {
      var dt = now - last;
      last = now;
      offset -= speed * (dt / 16.67);
      if (offset <= -setWidth) offset += setWidth;
      track.style.transform = 'translateX(' + offset + 'px)';
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  /* ── Global iframe cart handler ─────────────────── */
  window.addEventListener('message', function(e) {
    if (isDesignMode) return;
    if (e.data && e.data.type === 'korr-cart-add' && e.data.items) {
      var cartRoot = '/';
      try {
        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
          cartRoot = String(window.Shopify.routes.root);
        }
      } catch (x) {}
      if (cartRoot.slice(-1) !== '/') cartRoot += '/';
      var cartUrl = cartRoot + 'cart';
      var addUrl = cartRoot + 'cart/add.js';
      var updUrl = cartRoot + 'cart/update.js';
      var cartJs = cartRoot + 'cart.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: e.data.items })
      }).then(function(r) { return r.json().then(function(body) { if (!r.ok) throw body; return body; }); }).then(function() {
        if (e.data.discountCode) {
          var bundleIds = e.data.bundleVariantIds;
          if (!bundleIds || !bundleIds.length) {
            try { console.warn('korr-cart-add: routine discount skipped (bundleVariantIds required)'); } catch (x0) {}
          } else {
          var code = String(e.data.discountCode).trim();
          var cartWithCode = cartUrl + '?discount=' + encodeURIComponent(code);
          function mergeBundleAttr(cart) {
            var map = {};
            try {
              var prev = (cart && cart.attributes && cart.attributes.korr_bundle_required_variants) || '';
              String(prev).split(',').forEach(function(x) {
                var n = parseInt(x, 10);
                if (n) map[n] = true;
              });
              bundleIds.forEach(function(v) {
                var n = parseInt(v, 10);
                if (n) map[n] = true;
              });
            } catch (x1) {}
            return Object.keys(map).map(function(k) { return parseInt(k, 10); }).sort(function(a, b) { return a - b; }).join(',');
          }
          function buildPayload(cart) {
            var merged = mergeBundleAttr(cart);
            var p = { discount: code };
            if (merged) p.attributes = { korr_bundle_required_variants: merged };
            return p;
          }
          function postUpdateJson(payload) {
            return fetch(updUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload)
            }).then(function(r) {
              return r.json().then(function(body) { if (!r.ok) throw body; return body; });
            });
          }
          function postUpdateFd(payload) {
            var fd = new FormData();
            fd.append('discount', payload.discount);
            if (payload.attributes) {
              Object.keys(payload.attributes).forEach(function(k) {
                fd.append('attributes[' + k + ']', payload.attributes[k]);
              });
            }
            return fetch(updUrl, { method: 'POST', body: fd }).then(function(r) {
              return r.json().then(function(body) { if (!r.ok) throw body; return body; });
            });
          }
          /* Discount only with full routine: store required variant ids on the cart for validation on /cart */
          return fetch(cartJs).then(function(r) { return r.json(); }).then(function(cart) {
            return postUpdateJson(buildPayload(cart));
          }).then(function() {
            safeRedirect(cartWithCode, false);
          }).catch(function() {
            return fetch(cartJs).then(function(r) { return r.json(); }).then(function(cart) {
              return postUpdateFd(buildPayload(cart));
            }).then(function() {
              safeRedirect(cartWithCode, false);
            }).catch(function() {
              safeRedirect(cartRoot + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartWithCode), false);
            });
          });
          }
        }
        var countEl = document.querySelector('.v-cart-count');
        if (countEl) {
          fetch(cartJs).then(function(r) { return r.json(); }).then(function(cart) {
            countEl.textContent = cart.item_count;
            countEl.style.display = cart.item_count > 0 ? '' : 'none';
          });
        }
      }).catch(function(err) { try { console.warn('korr-cart-add', err); } catch (x) {} });
    }
  });

  /* ── Routine bundle: remove ROUTINE-style discount if any locked-in variant is gone ── */
  (function korrRoutineBundleDiscountGuard() {
    if (isDesignMode) return;
    try {
      var cr = '/';
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        cr = String(window.Shopify.routes.root);
      }
      if (cr.slice(-1) !== '/') cr += '/';
      var upd = cr + 'cart/update.js';
      var cartPage = cr + 'cart';
      if (!/\/cart\/?$/.test(window.location.pathname || '')) return;
      fetch(cr + 'cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var raw = cart.attributes && cart.attributes.korr_bundle_required_variants;
        if (!raw || !String(raw).trim()) return;
        var need = String(raw).split(',').map(function(x) { return parseInt(x, 10); }).filter(function(n) { return n > 0; });
        if (!need.length) return;
        var qty = {};
        (cart.items || []).forEach(function(li) {
          var vid = li.variant_id;
          qty[vid] = (qty[vid] || 0) + li.quantity;
        });
        if (!need.some(function(vid) { return (qty[vid] || 0) < 1; })) return;
        return fetch(upd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '', attributes: { korr_bundle_required_variants: '' } })
        }).then(function() {
          safeRedirect(cartPage, true);
        });
      }).catch(function() {});
    } catch (e2) {}
  })();

  /* ── Cinematic hero scroll sync ───────────────── */
  var heroWrap = document.getElementById('korr-hero-wrap');
  var heroFrame = document.getElementById('korr-hero-frame');
  if (heroWrap && heroFrame) {
    var lastP = -1;
    function syncHero() {
      var rect = heroWrap.getBoundingClientRect();
      var h = rect.height - window.innerHeight;
      var p = h > 0 ? Math.max(0, Math.min(1, -rect.top / h)) : 0;
      if (Math.abs(p - lastP) > 0.002) {
        lastP = p;
        try {
          heroFrame.contentWindow.postMessage({ type: 'korr:scroll', progress: p }, '*');
          heroFrame.contentWindow.postMessage({ type: 'korr-hero-scroll', progress: p }, '*');
        } catch(e) {}
      }
      requestAnimationFrame(syncHero);
    }
    requestAnimationFrame(syncHero);
  }

  /* ── Sticky header shadow on scroll ─────────────── */
  var header = document.querySelector('.v-header');
  if (header) {
    function onHeaderScroll() {
      if (window.scrollY > 10) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  /* ── Mobile menu toggle ─────────────────────────── */
  var hamburger = document.querySelector('.v-hamburger');
  var mobileMenu = document.querySelector('.v-mobile-menu');
  var mobileClose = document.querySelector('.v-mobile-close');
  var mobileOverlay = document.querySelector('.v-mobile-overlay');

  function openMobile() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (hamburger) {
      hamburger.classList.add('is-active');
      hamburger.setAttribute('aria-expanded', 'true');
    }
    document.body.style.overflow = 'hidden';
  }
  function closeMobile() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (hamburger) {
      hamburger.classList.remove('is-active');
      hamburger.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMobile);
  if (mobileClose) mobileClose.addEventListener('click', closeMobile);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobile);

  /* ── Search overlay toggle ──────────────────────── */
  var searchBtns = document.querySelectorAll('.v-search-open');
  var searchOverlay = document.querySelector('.v-search-overlay');
  var searchClose = document.querySelector('.v-search-overlay-close');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    var inp = searchOverlay.querySelector('input');
    if (inp) setTimeout(function(){ inp.focus(); }, 380);
    document.body.style.overflow = 'hidden';
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var ow = searchOverlay.querySelector('.v-search-field-wrap');
    if (ow) {
      var sl = ow.querySelector('.v-search-suggestions');
      if (sl) { sl.hidden = true; sl.innerHTML = ''; }
      var oi = ow.querySelector('input[name="q"]');
      if (oi) oi.setAttribute('aria-expanded', 'false');
    }
  }

  searchBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openSearch();
    });
  });
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) searchOverlay.addEventListener('click', function(e) {
    if (e.target === searchOverlay) closeSearch();
  });

  /* ── Predictive search (Shopify /search/suggest.json) ── */
  (function korrPredictiveSearch() {
    var debounceMs = 240;
    var minChars = 2;
    var maxItems = 8;

    function thumbUrl(p) {
      if (!p) return '';
      if (p.featured_image && p.featured_image.url) return p.featured_image.url;
      if (p.image) return p.image;
      return '';
    }
    function collThumb(c) {
      if (!c || !c.featured_image) return '';
      return c.featured_image.url || '';
    }
    function buildRows(res) {
      var out = [];
      var qlist = (res && res.queries) || [];
      var plist = (res && res.products) || [];
      var clist = (res && res.collections) || [];
      var i;
      for (i = 0; i < qlist.length && out.length < maxItems; i++) {
        var q = qlist[i];
        if (q && q.text && q.url) {
          out.push({ kind: 'Search', text: q.text, url: q.url, img: '' });
        }
      }
      for (i = 0; i < plist.length && out.length < maxItems; i++) {
        var p = plist[i];
        if (p && p.title && p.url) {
          out.push({ kind: 'Product', text: p.title, url: p.url, img: thumbUrl(p) });
        }
      }
      for (i = 0; i < clist.length && out.length < maxItems; i++) {
        var c = clist[i];
        if (c && c.title && c.url) {
          out.push({ kind: 'Collection', text: c.title, url: c.url, img: collThumb(c) });
        }
      }
      return out;
    }
    function renderList(listEl, rows) {
      listEl.innerHTML = '';
      if (!rows.length) {
        listEl.hidden = true;
        return;
      }
      rows.forEach(function(row) {
        var a = document.createElement('a');
        a.className = 'v-search-suggestion';
        a.href = row.url;
        a.setAttribute('role', 'option');
        if (row.img) {
          var im = document.createElement('img');
          im.src = row.img;
          im.alt = '';
          im.width = 42;
          im.height = 42;
          im.loading = 'lazy';
          a.appendChild(im);
        }
        var sp = document.createElement('span');
        sp.textContent = row.text;
        a.appendChild(sp);
        var ty = document.createElement('span');
        ty.className = 'v-search-suggestion-type';
        ty.textContent = row.kind;
        a.appendChild(ty);
        listEl.appendChild(a);
      });
      listEl.hidden = false;
    }
    function initWrap(wrap) {
      var form = wrap.querySelector('form[data-predictive-url]');
      var list = wrap.querySelector('.v-search-suggestions');
      if (!form || !list) return;
      var input = form.querySelector('input[name="q"]');
      var endpoint = form.getAttribute('data-predictive-url');
      if (!input || !endpoint) return;

      var t = null;
      var seq = 0;
      var abortCtrl = null;

      function hide() {
        list.hidden = true;
        list.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
      }

      function scheduleFetch() {
        var q = (input.value || '').trim();
        if (t) clearTimeout(t);
        if (abortCtrl) abortCtrl.abort();
        if (q.length < minChars) {
          hide();
          return;
        }
        t = setTimeout(function() {
          var my = ++seq;
          abortCtrl = new AbortController();
          var url = endpoint + (endpoint.indexOf('?') >= 0 ? '&' : '?') +
            'q=' + encodeURIComponent(q) +
            '&resources[type]=' + encodeURIComponent('query,product,collection') +
            '&resources[limit]=' + String(maxItems) +
            '&resources[limit_scope]=all';
          fetch(url, { signal: abortCtrl.signal, credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function(r) {
              if (!r.ok) throw new Error('predictive HTTP ' + r.status);
              return r.json();
            })
            .then(function(data) {
              if (my !== seq) return;
              var results = data && data.resources && data.resources.results;
              if (!results) {
                hide();
                return;
              }
              var rows = buildRows(results);
              if (!rows.length) {
                hide();
                return;
              }
              renderList(list, rows);
              input.setAttribute('aria-expanded', 'true');
            })
            .catch(function(err) {
              if (err && err.name === 'AbortError') return;
              if (my === seq) hide();
            });
        }, debounceMs);
      }

      input.addEventListener('input', scheduleFetch);
      input.addEventListener('focus', function() {
        if ((input.value || '').trim().length >= minChars) scheduleFetch();
      });
      input.addEventListener('keydown', function(ev) {
        if (ev.key === 'Escape') hide();
      });
      form.addEventListener('submit', function() {
        hide();
      });
      document.addEventListener('click', function(ev) {
        if (!wrap.contains(ev.target)) hide();
      });
    }

    document.querySelectorAll('.v-search-field-wrap').forEach(initWrap);
  })();

  /* ── Escape key closes all overlays ─────────────── */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobile();
    }
  });

  /* ── Smooth scroll for anchor links ─────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var hash = a.getAttribute('href');
      if (!hash || hash.length < 2) return;
      var target = document.querySelector(hash);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── PDP thumbnail gallery switching ────────────── */
  var mainImg = document.querySelector('.v-pdp-main-img');
  var thumbs = document.querySelectorAll('.v-pdp-thumb');

  if (mainImg && thumbs.length) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var img = thumb.querySelector('img');
        if (!img) return;
        var src = img.src.replace(/width=\d+/, 'width=1800');
        mainImg.style.opacity = '0';
        setTimeout(function() {
          mainImg.src = src;
          mainImg.onload = function() { mainImg.style.opacity = '1'; };
        }, 260);
      });
    });
    if (thumbs[0]) thumbs[0].classList.add('is-active');
  }

  /* ── Scroll-reveal (IntersectionObserver) ───────── */
  if ('IntersectionObserver' in window) {
    var revealTargets = document.querySelectorAll(
      '.v-section, .v-section-sm, .v-section-lg, .v-hero, .v-brands, .v-rewards, .v-newsletter'
    );
    var viewH = window.innerHeight || document.documentElement.clientHeight;
    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('v-reveal', 'is-visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -50px 0px' });
    revealTargets.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < viewH) {
        el.classList.add('v-reveal', 'is-visible');
      } else {
        el.classList.add('v-reveal');
        revealObs.observe(el);
      }
    });
  }

  /* ── Hide/show bottom nav on scroll direction ───── */
  var bottomNav = document.querySelector('.v-bottom-nav');
  if (bottomNav) {
    var lastScrollY = 0;
    var ticking = false;
    function updateBottomNav() {
      var sy = window.scrollY;
      if (sy > lastScrollY && sy > 200) {
        bottomNav.style.transform = 'translateY(100%)';
      } else {
        bottomNav.style.transform = 'translateY(0)';
      }
      lastScrollY = sy;
      ticking = false;
    }
    bottomNav.style.transition = 'transform .3s cubic-bezier(.4,0,.2,1)';
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateBottomNav);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── Lazy load images with native fallback ──────── */
  if ('loading' in HTMLImageElement.prototype) {
    document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
      if (img.dataset.src) img.src = img.dataset.src;
    });
  }

  /* ── Page-level search / filter (this page only) ── */
  function initPageFilters() {
    document.querySelectorAll('[data-page-filter]').forEach(function(bar) {
      var grid = bar.parentElement && bar.parentElement.querySelector('[data-filter-grid]');
      if (!grid) return;
      var qInput = bar.querySelector('[data-filter-q]');
      var sortSel = bar.querySelector('[data-filter-sort]');
      var stockSel = bar.querySelector('[data-filter-stock]');
      var resetBtn = bar.querySelector('[data-filter-reset]');
      var countEl = bar.querySelector('[data-filter-count]');
      var emptyEl = grid.querySelector('[data-filter-empty]');
      if (!emptyEl) {
        emptyEl = document.createElement('p');
        emptyEl.className = 'v-page-filter-empty';
        emptyEl.setAttribute('data-filter-empty', '');
        emptyEl.hidden = true;
        emptyEl.textContent = 'No items match your filters. Try adjusting search or reset the view.';
        grid.appendChild(emptyEl);
      }
      var items = Array.prototype.slice.call(grid.querySelectorAll('[data-filter-item]'));

      function norm(s) { return String(s || '').toLowerCase().trim(); }
      function getMeta(el) {
        return {
          title: norm(el.getAttribute('data-filter-title')),
          vendor: norm(el.getAttribute('data-filter-vendor')),
          tags: norm(el.getAttribute('data-filter-tags')),
          price: parseFloat(el.getAttribute('data-filter-price') || '0') || 0,
          available: el.getAttribute('data-filter-available') === '1'
        };
      }

      function apply() {
        var q = norm(qInput && qInput.value);
        var sort = sortSel ? sortSel.value : 'default';
        var stock = stockSel ? stockSel.value : 'all';
        var visible = [];
        items.forEach(function(el) {
          var m = getMeta(el);
          var hay = (m.title + ' ' + m.vendor + ' ' + m.tags).trim();
          var matchQ = !q || hay.indexOf(q) !== -1;
          var matchStock = stock === 'all' ||
            (stock === 'in' && m.available) ||
            (stock === 'out' && !m.available);
          var show = matchQ && matchStock;
          el.classList.toggle('v-filter-hidden', !show);
          if (show) visible.push({ el: el, meta: m });
        });
        if (sort !== 'default' && visible.length > 1) {
          visible.sort(function(a, b) {
            if (sort === 'price-asc') return a.meta.price - b.meta.price;
            if (sort === 'price-desc') return b.meta.price - a.meta.price;
            if (sort === 'name-asc') return a.meta.title.localeCompare(b.meta.title);
            if (sort === 'name-desc') return b.meta.title.localeCompare(a.meta.title);
            return 0;
          });
          visible.forEach(function(row) { grid.appendChild(row.el); });
        }
        var n = visible.length;
        if (countEl) {
          countEl.innerHTML = 'Showing <strong>' + n + '</strong> of <strong>' + items.length + '</strong>';
        }
        if (emptyEl) emptyEl.hidden = n > 0;
      }

      function reset() {
        if (qInput) qInput.value = '';
        if (sortSel) sortSel.value = 'default';
        if (stockSel) stockSel.value = 'all';
        apply();
      }

      if (qInput) {
        var t;
        qInput.addEventListener('input', function() {
          clearTimeout(t);
          t = setTimeout(apply, 120);
        });
      }
      if (sortSel) sortSel.addEventListener('change', apply);
      if (stockSel) stockSel.addEventListener('change', apply);
      if (resetBtn) resetBtn.addEventListener('click', reset);
      apply();
    });
  }
  initPageFilters();

})();
